<apx-chart
  [series]="options.series ?? series"
  [chart]="chartOptions"
  [dataLabels]="options.dataLabels ?? dataLabels"
  [markers]="options.markers ?? markers"
  [title]="options.title ?? title"
  [fill]="options.fill ?? fill"
  [yaxis]="options.yaxis ?? yaxis"
  [xaxis]="options.xaxis ?? xaxis"
  [tooltip]="options.tooltip ?? tooltip"
  [stroke]="options.stroke ?? stroke"
  [plotOptions]="options.plotOptions ?? plotOptions"
  [grid]="options.grid ?? grid"
  [colors]="options.colors ?? colors"
  [labels]="options.labels ?? labels"
  [responsive]="options.responsive ?? responsive"
  [legend]="options.legend ?? legend"
>
</apx-chart>
